import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tenantPickerMixin from '../core/tenant/pickerMixin';
import ApiService from '../../services/apiService';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import { get } from 'lodash';
export default {
  name: 'CoreDialogEula',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    open: {
      type: Boolean,
      "default": false
    },
    userId: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      termsAndConditions: '',
      title: ''
    };
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  watch: {
    userId: function userId() {
      var _this = this;
      if (!this.userId) {
        return;
      }
      ApiService.getUser(this, this.userId).then(function (user) {
        ApiService.getTermsAndConditions(user.access[0].tenantId).then(function (result) {
          _this.termsAndConditions = get(result, "termsAndConditions[0].termsAndConditions[".concat(localStorage.getItem('language') || 'de', "]"));
          _this.title = get(result, "termsAndConditions[0].termsAndConditions.title[".concat(localStorage.getItem('language') || 'de', "]"));
        })["catch"](function (error) {
          console.error(error);
        });
      })["catch"](function (error) {
        console.error(error);
      });
    }
  },
  methods: {
    handleAccept: function handleAccept() {
      var _this2 = this;
      ApiService.userAcceptEula().then(function () {
        _this2.$store.dispatch('authentication/verify')["catch"](function () {
          _this2.$snack('Error while accepting the agreement', 'error');
        });
      })["catch"](function () {
        _this2.$snack('Error while accepting the agreement', 'error');
        _this2.handleDecline();
      });
    },
    handleDecline: function handleDecline() {
      var _this3 = this;
      this.$store.dispatch('authentication/logout').then(function () {
        _this3.$router.push('/login');
      })["catch"](function () {
        // empty
      });
    }
  }
};